const getDateTime = () => {
  const date = new Date();
  // const time = date.getTime();
  return date.toLocaleString('en-US', {
    hour12: true,
  });
};

export default getDateTime;
